import { createAction } from '@elab/core/utils/dynaForms';

const submit = (storeName, options) => createAction(storeName, 'SUBMIT', options);

const initialize = (
    storeName,
    successRedirectLink,
    failRedirectLink,
    hostDialog,
    formElementId,
    formElement,
) =>
    createAction(storeName, 'INITIALIZE', {
        successRedirectLink,
        failRedirectLink,
        hostDialog,
        formElementId,
        formElement,
    });
const initializeDatafieldValue = (storeName, name, value) =>
    createAction(storeName, 'SET_DATA_FIELD_VALUE', {
        name,
        value,
        skipValidation: true,
    });

const setDatafieldValue = (storeName, name, value, skipValidation, prefill, save) =>
    createAction(storeName, 'SET_DATA_FIELD_VALUE', {
        name,
        value,
        skipValidation,
        prefill,
        save,
    });

const setFocused = storeName => createAction(storeName, 'SET_FOCUSED');
const setUnfocused = storeName => createAction(storeName, 'SET_UNFOCUSED');
const setSingleErrorMode = (storeName, name, value) =>
    createAction(storeName, 'SET_SINGLE_ERROR_MODE', {
        name,
        value,
    });
const setStepBack = storeName => createAction(storeName, 'SET_STEP_BACK');

const addFieldItem = (storeName, name, valueObj) =>
    createAction(storeName, 'ADD_FIELD_ITEM', { name, value: valueObj });
const removeFieldItem = (storeName, name, index) =>
    createAction(storeName, 'REMOVE_FIELD_ITEM', { name, index });

export default {
    submit,
    initialize,
    initializeDatafieldValue,
    setDatafieldValue,
    setFocused,
    setSingleErrorMode,
    setUnfocused,
    setStepBack,
    addFieldItem,
    removeFieldItem,
};
